// todo: move to shared frontend repo once created
/**
 * This is not fully unique but it adequte for general identifiers used wihin a similar time period
 */
function simpleId() {
  return Math.random().toString(36).substring(2, 7);
}
export default simpleId;
//# sourceMappingURL=simple-id.js.map